// extracted by mini-css-extract-plugin
module.exports = {"tagList":"styles_tagList__FbAOY","empty":"styles_empty__bvFea"};